import { useNavigate } from "react-router-dom";
import "./SchoolProjects.css";
import Footer from "../../assets/Footer/Footer";
import Navbar from "../../assets/Navbar/Navbar";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";

function SchoolProjects() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <Navbar />

      <div className="content-lo1-headings">
        <h1>School Projects</h1>
        <p>
          On this page I will be showcasing what projects I've done so far during
          my study at Fontys University of Applied Sciences
        </p>
      </div>

      <div className="line"></div>

      <div className="breadcrumb-wrap" style={{ padding: "0.1rem 7.5rem" }}>
        <BreadcrumbHeader />
      </div>

      <div className="content-lo1">
        <div className="content-lo1-card-container">
          {/* Tweekracht */}
          <div
            className="card-lo1 card-lo1--tweekracht"
            onClick={() => navigate("/school-projects/tweekrachtapp")}
          >
            <div className="card-lo1-media" />
            <h3 className="card-lo1-title">Tweekracht App</h3>
          </div>

          {/* Fontys Marketing */}
          <div
            className="card-lo1 card-lo1--fontysmarketing"
            onClick={() => navigate("/school-projects/fontys-marketing-campaign")}
          >
            <div className="card-lo1-media" />
            <h3 className="card-lo1-title">Fontys Marketing Campaign</h3>
          </div>

          {/* Jewellery Webshop */}
          <div
            className="card-lo1 card-lo1--jewellery"
            onClick={() => navigate("/school-projects/jewellery-webshop")}
          >
            <div className="card-lo1-media" />
            <h3 className="card-lo1-title">Jewellery Webshop</h3>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default SchoolProjects;
